import React, { Fragment, useState } from "react";
import { getShippingItemByWeight, ShippingCustomWeight } from "./functions";
import PaymentForm from "../square/PaymentForm";
import Loading from "../assets/Loading";
import { Button } from "@material-ui/core";
import { Delete, TenMp } from "@mui/icons-material";

const calculateCart = (items, shippingItem, fullfilment, orderCallback) => {
  console.log("calculateCart");
  console.log(items);
  console.log(shippingItem);
  fetch("/giftshop/cart/calculate", {
    method: "POST", // *GET, POST, PUT, DELETE, etc.
    body: JSON.stringify({
      items: shippingItem != null ? { ...items, shippingItem } : items,
      fullfilment: fullfilment,
    }),
    headers: { "Content-Type": "application/json" },
  })
    .then((response) => response.json())
    .then((data) => {
      console.log("Calc");
      console.log(data);
      if (data.order != null) {
        orderCallback(data.order);
      }
    });
};

export default (props) => {
  const [showDetailView, setShowDetailView] = useState(false);
  console.log(props.items);
  return (
    <Fragment>
      <CartDetailView
        cartItems={props.items}
        shippingItems={props.shippingItems}
        show={showDetailView}
        onClose={setShowDetailView}
      />
      <div
        className="shopping-cart"
        onClick={() => setShowDetailView(!showDetailView)}
      >
        <img style={{ float: "left" }} src="/assets/shopping-cart-icon" />
        View Cart({Object.keys(props.items).length})
      </div>
    </Fragment>
  );
};

export const CartDetailView = (props) => {
  const [cartItems, setCartItems] = useState({});
  const [taxes, setTaxes] = useState([]);
  const [order, setOrder] = useState();
  const [fullfilment, setFullfilment] = useState();
  const [checkoutState, setCheckoutState] = useState("view");
  const [localPickup, setLocalPickup] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [weight, setWeight] = useState(0);

  React.useEffect(() => {
    console.log(props);
    console.log(props.cartItems.length);
    setCartItems(props.cartItems);
  }, [props.cartItems]);

  const onWeightChanged = (items) => {
    console.log(items);
    let tempWeight = 0;

    Object.keys(items).forEach((key) => {
      console.log("Attr?");
      console.log(items[key].itemData.custom_attribute_values);
      console.log(
        items[key].itemData.custom_attribute_values[ShippingCustomWeight]
      );
      if (
        items[key].itemData.custom_attribute_values != null &&
        items[key].itemData.custom_attribute_values[ShippingCustomWeight] !=
          null
      ) {
        let itemWeight = parseFloat(
          items[key].itemData.custom_attribute_values[ShippingCustomWeight]
            .number_value
        );
        items[key].variations.map((v) => {
          console.log(`Adding: ${itemWeight * v.qty}lbs`);
          tempWeight += itemWeight * v.qty;
        });
      }
    });

    console.log(weight);

    setWeight(tempWeight);
  };

  const qtyUpdated = (itemID, variationId, taxId, qty) => {
    console.log(itemID);
    console.log(variationId);
    console.log(taxId);
    console.log(qty);
    console.log(props.cartItems);
    if (cartItems) {
      if (qty == null) {
        console.log("Handling Removed Item");
        let item = cartItems[itemID];
        let v = cartItems[itemID].variations.filter(
          (v) => v.id == variationId
        )[0];
        let removed = cartItems[itemID].variations.filter(
          (v) => v.id != variationId
        );

        let proceed = confirm(
          `Are you sure you want to remove ${item.itemData.item_data.name} - ${v.item_variation_data.name} from the cart?`
        );
        if (proceed) {
          if (removed.length == 0) {
            console.log("Removing Item");
            let cartItemsCopied = { ...cartItems };
            delete cartItemsCopied[itemID];
            // Handle Weight
            onWeightChanged(cartItemsCopied);
            setCartItems(cartItemsCopied);
          } else {
            console.log("Removing Variation");
            item.variations = removed;
            let cartItemsCopied = { ...cartItems };
            cartItemsCopied[itemID] = item;
            // Handle Weight
            onWeightChanged(cartItemsCopied);
            setCartItems(cartItemsCopied);
          }
        }
      } else if (cartItems) {
        console.log("Handling QTY Updated Item");
        let removed = cartItems[itemID].variations.filter(
          (v) => v.id != variationId
        );
        let variation = cartItems[itemID].variations.filter(
          (v) => v.id == variationId
        )[0];
        variation.qty = qty;
        console.log(variation);
        removed.push(variation);
        let item = cartItems[itemID];
        item.variations = removed;
        let cartItemsCopied = { ...cartItems };
        cartItemsCopied[itemID] = item;
        // Handle Weight
        onWeightChanged(cartItemsCopied);
        setCartItems(cartItemsCopied);
      }
    }
  };

  const calculateOrderCallback = (order) => {
    console.log("Order:" + order);
    setTaxes(order.taxes);
    setOrder(order);
    setCheckoutState("payment");
    setIsLoading(false);
  };

  const orderCallback = (order) => {
    console.log("Order:" + order);
    setTaxes(order.taxes);
    setOrder(order);
    setCheckoutState("payment");
    setIsLoading(false);
  };

  const getButton = (checkoutState) => {
    switch (checkoutState) {
      case "view":
        return (
          <div
            className="purple-button"
            onClick={() => setCheckoutState("shipping")}
          >
            Checkout
          </div>
        );
      case "shipping":
        return (
          <div
            className="purple-button"
            onClick={() => {
              setIsLoading(true);
              calculateCart(
                cartItems,
                localPickup ? null : shippingItem,
                fullfilment,
                calculateOrderCallback
              );
            }}
          >
            Calculate Total
          </div>
        );
      case "payment":
        break;
    }
  };

  const getContent = () => {
    return (
      <div
        className="item-container-selected-overlay"
        style={{ display: props.show ? "block" : "none" }}
      >
        {isLoading ? <Loading /> : <></>}
        <div id="cart-detail-view" className="item-container-selected">
          <span
            className="close-dialog-button"
            onClick={() => props.onClose(false)}
          >
            X
          </span>
          <table style={{ marginTop: "15%" }}>
            <tr style={{ background: "white" }}>
              <th></th>
              <th style={{ paddingLeft: "5%" }}>Product</th>
              <th>Quantity</th>
              <th>Price</th>
            </tr>
            {Object.keys(cartItems).map((key) => {
              return (
                <CartItem
                  id={key}
                  cartItem={cartItems[key]}
                  onQtyChanged={qtyUpdated}
                  checkoutState={checkoutState}
                  onItemRemoved={qtyUpdated}
                />
              );
            })}
          </table>
          <Subtotals
            taxes={taxes}
            shippingItem={localPickup ? null : shippingItem}
            total={order != null ? order.total_money.amount : null}
          />
          {checkoutState == "shipping" ? (
            <ShippingOptions callback={setLocalPickup} />
          ) : (
            ""
          )}
          <PaymentForm
            orderItems={cartItems}
            shippingItem={localPickup ? null : shippingItem}
            isPickup={localPickup}
            order={order}
            fullfilmentCallback={setFullfilment}
            checkoutState={checkoutState}
            total={order != null ? order.total_money.amount : null}
          />
          {getButton(checkoutState)}
        </div>
      </div>
    );
  };

  const shippingItem =
    Object.keys(cartItems).length > 0
      ? getShippingItemByWeight(props.shippingItems, weight)
      : null;
  console.log("Shipping Item:");
  console.log(shippingItem);
  return getContent();
};

const ShippingOptions = (props) => {
  const [shippingOption, setShippingOption] = useState("standard");
  function setShipping(option) {
    setShippingOption(option);
    props.callback(option == "local-pickup");
  }
  return (
    <div className="shipping-container">
      <div className="select-item" onClick={() => setShipping("standard")}>
        <div
          className="select-radio"
          style={{
            "--color": shippingOption == "standard" ? "#009CAB" : "transparent",
          }}
        />
        <div className="select-item-label"> Standard Shipping</div>
      </div>
      <div className="select-item" onClick={() => setShipping("local-pickup")}>
        <div
          className="select-radio"
          style={{
            "--color":
              shippingOption == "local-pickup" ? "#009CAB" : "transparent",
          }}
        />
        <div className="select-item-label">
          {" "}
          Local Pickup <span className="note">in Ballston Spa, NY</span>
        </div>
      </div>
    </div>
  );
};

const Subtotals = (props) => {
  console.log(props.shippingItem);

  var taxes =
    props.taxes != null ? (
      props.taxes.map((t) => {
        return (
          <Fragment>
            <div className="cart-item-variation-container">
              <span className="cart-item-qty-label">{t.name}</span>
              <span className="cart-item-qty-label">
                ${(t.applied_money.amount / 100).toFixed(2)} (%{t.percentage})
              </span>
            </div>
          </Fragment>
        );
      })
    ) : (
      <Fragment></Fragment>
    );
  var shipping =
    props.shippingItem != null ? (
      <Fragment>
        <span className="cart-item-name">Shipping</span>
        <div className="cart-item-variation-container">
          <span className="cart-item-qty-label">
            {props.shippingItem.itemData.name}
          </span>
          <span className="cart-item-qty-label">
            $
            {props.shippingItem.itemData.variation.item_variation_data
              .price_money.amount / 100}
          </span>
        </div>
      </Fragment>
    ) : (
      <Fragment></Fragment>
    );
  var total =
    props.total != null ? (
      <Fragment>
        <span className="cart-item-name">Total</span>
        <div className="cart-item-variation-container">
          <span className="cart-item-qty-label">Amount</span>
          <span className="cart-item-qty-label">${props.total / 100}</span>
        </div>
      </Fragment>
    ) : (
      <Fragment></Fragment>
    );
  return (
    <Fragment>
      <span className="cart-item-name">{taxes.length > 0 ? "Taxes" : ""}</span>
      <div className="cart-item-row">{taxes}</div>
      <div className="cart-item-row">{shipping}</div>
      <div className="cart-item-row">{total}</div>
    </Fragment>
  );
};

const CartItem = (props) => {
  console.log("Item");
  console.log(props);
  return (
    <tr
      className="cart-item-row"
      key={props.id}
      style={{ background: "white" }}
    >
      <td style={{ width: "15%" }}>
        <div
          className="cart-item-image-thumb"
          style={{
            "--src": `url(${
              props.cartItem.itemData.imageData
                ? props.cartItem.itemData.imageData
                : "/assets/llama-placeholder.png"
            })`,
          }}
        />
      </td>
      {props.cartItem.variations != null
        ? props.cartItem.variations.map((v) => {
            return (
              <CartItemVariation
                itemId={props.cartItem.itemData.id}
                itemName={props.cartItem.itemData.item_data.name}
                variation={v}
                onQtyChanged={props.onQtyChanged}
                checkoutState={props.checkoutState}
                onRemovedFromCart={props.onItemRemoved}
              />
            );
          })
        : props.cartItem.itemData.variations.map((v) => {
            return (
              <CartItemVariation
                itemId={props.cartItem.itemData.id}
                itemName={props.cartItem.itemData.item_data.name}
                variation={v}
                onQtyChanged={props.onQtyChanged}
                checkoutState={props.checkoutState}
                onRemovedFromCart={props.onItemRemoved}
              />
            );
          })}
    </tr>
  );
};

const CartItemVariation = (props) => {
  const [qty, setQty] = useState(props.variation.qty);
  React.useEffect(() => {
    updateQty(props.variation.qty);
  }, [props.variation.qty]);

  const updateQty = (qty) => {
    props.onQtyChanged(props.itemId, props.variation.id, "taxId", qty);
    setQty(qty);
  };

  return (
    <Fragment>
      <td style={{ padding: "5%", width: "30%" }}>
        <span className="cart-item-qty-label" style={{ fontWeight: "bold" }}>
          {props.itemName}
        </span>
        <span className="cart-item-qty-label">
          {props.variation.item_variation_data.name}
        </span>
      </td>
      <td style={{ width: "10%" }}>
        {props.checkoutState != "payment" ? (
          <NumInput
            className="event-people-num-input"
            value={qty}
            min={1}
            max={props.variation.stock}
            onIncrement={(qty) => {
              console.log(qty);
              if (qty == 0) {
                console.log("Removing From Cart!");
                props.onRemovedFromCart(props.itemId, props.variation.id);
              } else if (qty > props.variation.stock) {
                updateQty(props.variation.stock);
              } else {
                updateQty(qty);
              }
            }}
          />
        ) : (
          <>X{qty}</>
        )}
      </td>
      <td style={{ width: "10%" }}>
        {" "}
        <span className="cart-item-qty-label">
          $
          {(
            (props.variation.item_variation_data.price_money.amount / 100) *
            qty
          ).toFixed(2)}
        </span>
      </td>
    </Fragment>
  );
};

const NumInput = (props) => {
  const increment = (newValue) => {
    props.onIncrement(newValue < 0 ? 0 : newValue);
  };
  var numInput = (
    <input
      key={`${props.key}-input`}
      id={props.id}
      type="number"
      min={props.min}
      max={props.max}
      value={props.value != null ? props.value : 0}
      className={props.className}
      style={{ background: "#e5e5e5" }}
    />
  );
  return (
    <div
      key={`${props.key}-fragment`}
      style={{ display: "flex", float: "left" }}
    >
      <div className="number-input" style={{ margin: "0px" }}>
        <button
          key={`${props.key}-arrow-up`}
          onClick={() => {
            if (props.value > 0) {
              increment(props.value - 1);
            }
          }}
        />
        {numInput}
        <button
          key={`${props.key}-input-arrow-down`}
          className="arrow"
          onClick={() => {
            increment(props.value + 1);
          }}
        />
      </div>
      <Button startIcon={<Delete />} onClick={() => increment(0)}>
        Remove
      </Button>
    </div>
  );
};
